import { render } from "./SplitsCalendar.vue?vue&type=template&id=250bf926&scoped=true"
import script from "./SplitsCalendar.vue?vue&type=script&lang=js"
export * from "./SplitsCalendar.vue?vue&type=script&lang=js"

import "./SplitsCalendar.vue?vue&type=style&index=0&id=250bf926&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250bf926"]])

export default __exports__